<template>
  <editor :id="id" default-tab="list_type" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import ListTypeEditor from './ListTypeEditor'
export default {
  props: ['id'],
  components: {
    Editor
  },
  data() {
    return {
      tabs: [
        {title: "List Type", name: "list_type", component: ListTypeEditor}
      ]
    }
  }
}
</script>
